var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.499 0.00292683C10.4993 0.00200552 10.5007 0.00200574 10.501 0.00292705L12.8572 7.25463C12.8573 7.25504 12.8577 7.25532 12.8581 7.25532H20.483C20.484 7.25532 20.4844 7.25656 20.4836 7.25713L14.3149 11.7389C14.3146 11.7392 14.3144 11.7396 14.3146 11.74L16.6708 18.9918C16.6711 18.9927 16.67 18.9934 16.6693 18.9929L10.5006 14.5111C10.5002 14.5108 10.4998 14.5108 10.4994 14.5111L4.33074 18.9929C4.32996 18.9934 4.32891 18.9927 4.32921 18.9918L6.68543 11.74C6.68556 11.7396 6.68541 11.7392 6.68506 11.7389L0.516396 7.25713C0.515612 7.25656 0.516015 7.25532 0.516984 7.25532H8.14188C8.14231 7.25532 8.14269 7.25504 8.14283 7.25463L10.499 0.00292683Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarWhite);
export default __webpack_public_path__ + "static/media/starWhite.0a4dcc311ccd22075614b30ad589db4e.svg";
export { ForwardRef as ReactComponent };